/** @format */

import {Box} from '@mui/material';

import {BarColor} from '../helpers';
import ResolvedLine from './ResolvedLine';

export interface BarData {
  width: number;
  color: BarColor;
}

export interface ResolvedCellData {
  display: number | string;
  bar: BarData | null;
}

const ResolvedCell = ({display, bar}: ResolvedCellData) => (
  <Box sx={{display: 'flex', alignItems: 'center'}}>
    <Box sx={{minWidth: '40px', textAlign: 'right'}}>{display}</Box>
    {bar && <ResolvedLine value={bar.width} bgColor={bar.color} />}
  </Box>
);

export default ResolvedCell;
